import styled from '@emotion/styled';

export const StyledBottomNavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  padding-bottom: 24px;
  height: 100%;
`;

export const StyledSettingsPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-top: 45px;
`;
